import React, { useEffect, useRef, useState } from "react";
import NavBar from "./navBar";
import Address from "./address";
import { Formik } from "formik";
import { json, useLocation } from "react-router-dom";
import Contacts from "./contacts";
import Family from "./family";
import Banking from "./banking";
import Payment from "./payment";
import LoadingOverlay from "../helper-components/overlay-loading";
import General from "./general";
import Patient from "./patient";
import Insurance from "./insurance";
import Accounting from "./accounting";
import Otp from "./otp";
import VerificationPopup from "./verificationPopUp";
import CreateAbha from "./abha/create-abha";
import MainPage from "./find-abha/main-page";

function AdminCusCreateEditViewn({
  // customerId,
  // setCustomerId,
  reload,
  setReload,
  customerDetails,
  page,
  disabled,
  initialData,
  cmrId,
  tab,
}) {
  const generalFunction = () => {
    if (page === "add") return false;
    else return true;
  };
  const initialTabs = [
    "General Info",
    "Contacts",
    "Banking",
    "Payment",
    "Accounting",
    "Address",
    "Patient Info",
    "Family Info",
    "Insurance",
  ];
  const tabNames = [
    // use it for customizing nav bar
    { label: "General Info", value: "general" },
    { label: "Contacts", value: "contacts" },
    { label: "Banking", value: "bank" },
    { label: "Payment", value: "payment" },
    { label: "Accounting", value: "accounting" },
    { label: "Address", value: "address" },
    { label: "Patient Info", value: "patient" },
    { label: "Family Info", value: "family" },
    { label: "Insurance", value: "insurance" },
  ];

  const [currentTab, setCurrentTab] = useState(tab || "General Info");
  const [tabs, setTabs] = useState([...initialTabs]);
  const [nav, setNav] = useState([]);

  const [customerId, setCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [generalCreated, setGeneralCreated] = useState(generalFunction());
  ///
  const [contactId, setContactId] = useState(null);
  const [pay, setPay] = useState(null);
  const [shipping, setShipping] = useState(null);
  const [banking, setBanking] = useState(null);
  const [family, setFamily] = useState(null);
  const [insurance, setInsurance] = useState(null);
  const [patient, setPatient] = useState(null);
  const [payment, setPayment] = useState(null);
  const [customization, setCustomization] = useState(null);
  //ABHA otp
  const [ABHAverified, setABHAverified] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [tokenExpiresIn, setTokenExpiresIn] = useState(0);
  const [txnId, setTxnId] = useState("");
  const [accessToken, setAccessToken] = useState("");
  ///ABHA create
  const [ABHAcreate, setABHAcreate] = useState(false);
  const [createABHApopUp, setCreateABHApopUp] = useState(false);
  const [findABHApopup, setFindABHApopup] = useState(false);

  // const [initialData, setInitialData] = useState(null);

  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (initialData?.general.cmr_type === "business") {
      setTabs([
        "General Info",
        "Contacts",
        "Banking",
        "Payment",
        "Accounting",
        "Address",
      ]);
    }
  }, []);
  // useEffect(() => {
  //   if (isInitialLoad.current) {
  //     // This is the initial page load (refresh), don't clear localStorage
  //     isInitialLoad.current = false;
  //   } else {
  //     // This is a route change, clear localStorage
  //     localStorage.removeItem("customerAdmin");
  //   }
  // }, [location.pathname]);

  //
  useEffect(() => {
    const localStorageData = JSON.parse(localStorage.getItem("ModPermission"));
    if (localStorageData) {
      const cusData = localStorageData.find((obj) => obj?.party_create);
      if (cusData?.party_create) {
        setCustomization(cusData?.party_create);
        console.log("Customization Data:", cusData?.party_create);
      }
    }
  }, []);
  useEffect(() => {
    setCustomerId(cmrId);
  }, [cmrId]);
  //
  useEffect(() => {
    if (page !== "add") {
      setCustomerId(customerDetails.general.cmr_id);
    } else {
      if (!localStorage.getItem("customerAdmin")) {
        localStorage.setItem("customerAdmin", JSON.stringify(initialData));
      }
    }
  }, [page, initialData]);

  return (
    <>
      {/* {popUp && <Otp setPopUp={setPopUp} />} */}
      {createABHApopUp && (
        <CreateAbha
          createABHApopUp={createABHApopUp}
          setCreateABHApopUp={setCreateABHApopUp}
        />
      )}
      {findABHApopup && (
        <MainPage
          findABHApopup={findABHApopup}
          setFindABHApopup={setFindABHApopup}
        />
      )}
      {popUp && (
        <VerificationPopup
          setPopUp={setPopUp}
          tokenExpiresIn={tokenExpiresIn}
          txnId={txnId}
          accessToken={accessToken}
          setABHAverified={setABHAverified}
        />
      )}

      <div className=" max-w-screen  mx-6">
        <LoadingOverlay isLoading={loading} />

        {console.log("~", initialData)}
        {console.log("~~", customerId)}

        <NavBar
          generalCreated={generalCreated}
          tabs={tabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
        {currentTab === "Address" && (
          <Address
            customization={customization}
            tabs={tabs}
            shippingId={shipping}
            payId={pay}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            addressPay={initialData.addressPay}
            addressShipping={initialData.addressShipping}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}

        {currentTab === "Contacts" && (
          <Contacts
            customization={customization}
            contactId={contactId}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            contacts={initialData.contacts}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "Family Info" && (
          <Family
            customization={customization}
            familyId={family}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            family={initialData.family}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "Banking" && (
          <Banking
            customization={customization}
            bankingId={banking}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            banking={initialData.banking}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "Payment" && (
          <Payment
            customization={customization}
            paymentId={payment}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            payment={initialData.payment}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "General Info" && (
          <General
            customization={customization}
            setGeneralCreated={setGeneralCreated}
            setContactId={setContactId}
            setPay={setPay}
            setShipping={setShipping}
            setBanking={setBanking}
            setFamily={setFamily}
            setInsurance={setInsurance}
            setPatient={setPatient}
            setPayment={setPayment}
            setTabs={setTabs}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            setCustomerId={setCustomerId}
            general={initialData.general}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "Patient Info" && (
          <Patient
            setFindABHApopup={setFindABHApopup}
            createABHApopUp={createABHApopUp}
            setCreateABHApopUp={setCreateABHApopUp}
            customization={customization}
            patientId={patient}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            patient={initialData.patient}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
            popUp={popUp}
            setPopUp={setPopUp}
            tokenExpiresIn={tokenExpiresIn}
            setTokenExpiresIn={setTokenExpiresIn}
            setTxnId={setTxnId}
            setABHAverified={setABHAverified}
            ABHAverified={ABHAverified}
            accessToken={accessToken}
            setAccessToken={setAccessToken}
          />
        )}
        {currentTab === "Insurance" && (
          <Insurance
            customization={customization}
            insuranceId={insurance}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            insurance={initialData.insurance}
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {currentTab === "Accounting" && (
          <Accounting
            customization={customization}
            setCurrentTab={setCurrentTab}
            customerId={customerId}
            // accounting={initialData.insurance} // need to be changed
            page={page}
            disabled={disabled}
            loading={loading}
            setLoading={setLoading}
          />
        )}
      </div>
    </>
  );
}

export default AdminCusCreateEditViewn;
